import Component from './faq'

export default Component